if (process.env.NODE_ENV === 'production') {
  module.exports = require('./switch.production.js');
} else {
  module.exports = require('./switch.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ux/switch/dist/es/switch.js
// module id = 1380
// module chunks = 0